import React from "react";
import { Control, Controller, RegisterOptions } from "react-hook-form";
import { Spacer } from "shared/layout";
import { SmallText } from "shared/styles";
import { IFormOption } from "shared/types";

import { FieldWrapper, FieldWrapperProps } from "../FieldWrapper";
import { Checkbox } from "./Checkbox";

interface CheckboxGroupProps extends FieldWrapperProps {
  options: IFormOption[];
  control: Control;
  validation?: RegisterOptions;
  onChange?: (value: any) => void;
  subText?: string;
}

export const CheckboxGroup: React.FC<CheckboxGroupProps> = ({
  name,
  options,
  control,
  validation,
  error,
  onChange: triggerOnChange,
  subText,
  ...rest
}) => (
  <Controller
    name={name}
    control={control}
    rules={validation}
    render={({ onChange, onBlur, value }) => (
      <FieldWrapper name={name} error={error} {...rest}>
        <Spacer size="s">
          <Spacer size="xxs">
            {options?.map((data, index) => (
              <Checkbox
                key={index}
                name={name}
                checked={value?.includes(data.value)}
                onChange={(e) => {
                  const { checked, value: checkboxValue } = e.target;
                  const oldValue = value || [];
                  let newValue;
                  if (checked) {
                    newValue = [...oldValue, checkboxValue];
                  } else {
                    newValue = oldValue.filter(
                      (id: string) => id !== checkboxValue
                    );
                  }
                  onChange(newValue?.length === 0 ? "" : newValue);
                  triggerOnChange && triggerOnChange(newValue);
                  // Blur so validation updates
                  onBlur();
                }}
                onBlur={onBlur}
                index={index}
                {...data}
              />
            ))}
          </Spacer>
          {subText && <SmallText>{subText}</SmallText>}
        </Spacer>
      </FieldWrapper>
    )}
  />
);
